import React, { useMemo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getPdfs } from "data/Querys";
import MirsTable from 'components/general/table/Table.js';
import Label from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import { getLevelRSCPdf, getRscObject } from 'helpers/rsc';
import PageHeader from 'components/common/PageHeader';
import moment from 'moment';
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import Selector_Event from "components/common/selectors/SelectorEvent";
import SelectorPdfType from 'components/common/selectors/selector-pdttype';
import { Stack } from "react-bootstrap";
import Competitor from 'components/presentation/Competitor';
import Noc from 'components/presentation/Noc';
import DateTime from 'components/presentation/DateTime';
import useViewport from 'components/general/useViewPort';


export default function Reports() {
    const [dataState, setDataState] = React.useState([]);
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_pdftype } = useUrlFriendlyToParameters()
    const placeholder = Label({ data: 'LabelSearch' });
    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['pdfsTable', mirs_competition, mirs_discipline],
            queryFn: getPdfs,
            refetchInterval: 30000,
        });

    const header = <PageHeader title={<Label data="Reports" />} />

    //posiciona al principio de la pásgina
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    //aplica los filtros 
    useEffect(() => {

        let filterData = data?.pdfs
        if (filterData && mirs_event && mirs_event !== "all-event") {
            filterData = filterData?.filter(item => item?.eventUnit?.code?.includes(mirs_event));
        }
        if (mirs_pdftype && mirs_pdftype !== "all-reports") {
            filterData = filterData?.filter(item => getLevelRSCPdf(item?.pdfCode, item.pdfType, item?.pdfSubcode) === mirs_pdftype);
        }
        setDataState(filterData);
    }, [data, mirs_discipline, mirs_event, mirs_pdftype]);





    if (isError) { return <>{header} <NotAvailable /></>; }
    if (isLoading) { return <>{header} <Loader /></>; }
    // if (!data?.pdfs) { return <>{header} <NotAvailable label='LabelNoData' /></>; }

    const handleOnChange = event => {
        const { name, value } = event.target;

        let filterData = data?.pdfs

        if (mirs_event && mirs_event !== "all-event") {
            filterData = filterData?.filter(item => item?.eventUnit?.code === mirs_event);
        }
        if (mirs_pdftype && mirs_pdftype !== "all-pdf") {
            filterData = filterData?.filter(item => getLevelRSCPdf(item?.pdfCode, item.pdfType, item?.pdfSubcode) === mirs_pdftype);
        }
        filterData = filterData?.filter(item =>
            item?.h1?.description?.toLowerCase().includes(value.toLowerCase())
            || item?.eventUnit?.schedule?.start[0]?.participant?.name?.toLowerCase().includes(value.toLowerCase())
            || item?.eventUnit?.schedule?.start[1]?.participant?.name?.toLowerCase().includes(value.toLowerCase())
            || item?.eventUnit?.schedule?.start[0]?.organisation?.code?.toLowerCase().includes(value.toLowerCase())
            || item?.eventUnit?.schedule?.start[1]?.organisation?.code?.toLowerCase().includes(value.toLowerCase())
            || item?.eventUnit?.longDescription?.toLowerCase().includes(value.toLowerCase())
        );
        setDataState(filterData)
    };


    return (
        <>
            {header}
            <Stack direction={isMobile ? 'vertical' : 'horizontal'}>
                <SelectorDiscipline display_type="combo" page="reports" />
                <Selector_Event display_type="combo" page="reports" />
                <SelectorPdfType page="reports" />
                <div className="d-flex">
                    <input type="text" className="form-control" name="PdfFilter" id="PdfFilter" placeholder={placeholder} onChange={handleOnChange} />
                </div>
            </Stack>
            {dataState && <PdfsTable data={dataState} key={`PdfsTable`} />}

        </>
    )
};


function getColumns() {
    return (
        [
            ColumnPdfType(),
            ColumnPdfName(),
            ColumnEvent({ label: "DocEvent" }),
            ColDateTime(),
            ColPdfLink()
        ]
    )
}

function getColumnsSM() {
    return (
        [
            ColumnPdfTypeNameEvent(),
            ColDateTime(),
            ColPdfLink()
        ]
    )
}

function ColumnPdfTypeNameEvent() {
    return (
        {
            Header: <Label data={'DocTypeNameEvent'} />,
            accessor: (props) => { return getLevelRSCPdf(props.pdfCode, props.pdfType, props.pdfSubcode) },
            className: "text-start",
            headerClassName: "text-start",
            disableSortBy: false,
            id: 'PdfType',
            Cell: props => (
                <Stack direction='vertical'>
                    <Stack>{getPdfType(props)}</Stack>
                    <Stack>{getPdfName(props)}</Stack>
                    <Stack>{getPdfEvent(props)}</Stack>
                </Stack>
                )
        }
    )
}




function ColumnPdfType() {
    return (
        {
            Header: <Label data={'DocType'} />,
            accessor: (props) => { return getLevelRSCPdf(props.pdfCode, props.pdfType, props.pdfSubcode) },
            className: "text-start",
            headerClassName: "text-start",
            disableSortBy: false,
            id: 'PdfType',
            Cell: props => getPdfType(props)
        }
    )
}




function ColumnPdfName() {
    return (
        {
            Header: <Label data={'DocName'} />,
            accessor: 'h1.description',
            className: "text-start",
            headerClassName: "text-start",
            disableSortBy: false,
            id: 'PdfName',
            Cell: props => getPdfName(props)
        }
    )
}

function ColDateTime() {
    return (
        {
            Header: <Label data={'HeaderdocDate'} />,
            accessor: props => props?.pdfDate + props?.pdfTime?.slice(0, 6),
            className: "text-start",
            headerClassName: "text-start",
            disableSortBy: false,
            id: 'PdfDateTime',
            Cell: (props) => {
                const row = props.cell.row.original
                const formatDate = Label({ data: 'FullDateTimeFormatNoSeconds' });
                const time = row?.pdfTime?.slice(0, 2) + ":" + row?.pdfTime?.slice(2, 4) + ":" + row?.pdfTime?.slice(4, 6) // <DateTime datetime={row?.pdfTime} format={"HH:mm"} />
                const dateTime = row?.pdfDate + ' ' + time;
                const dateTime2 = moment.tz(dateTime, process.env.REACT_APP_TIME_ZONE)
                return (
                    <>
                        <DateTime datetime={dateTime2} format={formatDate} />
                    </>
                )
            }
        }
    )

}

function ColPdfLink() {
    return (
        {
            Header: "",
            accessor: 'h1.description',
            className: "text-center",
            headerClassName: "text-start w-5",
            disableSortBy: true,
            id: 'PdfLink',
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <>
                        <a href={`${process.env.REACT_APP_SERVER_URL_RESOURCES}/pdf${row.fullPath}`} target="_blank">
                            <FontAwesomeIcon className="font-icon" icon={faFilePdf} />
                        </a>

                    </>
                )
            }
        }
    )

}


export function ColumnEvent({
    disableSort = false,
    label = "HeaderEvent"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'eventUnit.longDescription',
            className: 'schedule-event',
            headerClassName: 'schedule-event',
            disableSortBy: disableSort,
            id: 'Event',
            Cell: props => getPdfEvent(props)
        }
    )
}


const PdfsTable = ({ data }) => {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const columns = useMemo(() => isMobile ? getColumnsSM() : getColumns(), [isMobile]);
    return (
        <MirsTable
            className="table-schedule"
            id={'mirs-table-pdfs'}
            // data={data.pdfs}
            data={data}
            columns={columns}
            initialSortBy={[{ id: 'PdfDateTime', desc: true }]}
            showPagination={true}
            pageSizeCustom={10}

        />
    )
}


const getPdfType = (props) => {
    let lbl
    switch (props.value) {
        case "UNIT":
            lbl = <Label data={'EventUnitReports'} />
            break;
        case "PHASE":
            lbl = <Label data={'PhaseReports'} />
            break;
        case "EVENT":
            lbl = <Label data={'EventReports'} />
            break;
        case "DISCIPLINE":
            lbl = <Label data={'DisciplineReports'} />
            break;
        case "DATE":
            lbl = <Label data={'DateReports'} />
            break;
        case "COMMUNI":
            lbl = <><Label data={'LabelOfficialCommunications'} /></>
            break;
        case "SEX":
            lbl = <Label data={'LabelGenderReports'} />
            break;
        default:
            lbl = props.value
            break;
    }
    return lbl

}

const getPdfName = props => {
    const row = props.cell.row.original;
    let out = row?.h1?.description;
    const subcode = row?.pdfSubcode;

    switch (getLevelRSCPdf(row?.pdfCode, row?.pdfType, row?.pdfSubcode)) {
        case "DATE":
            const formatDate = Label({ data: 'LinkDateFormat2' });
            const dateTime = moment.tz(subcode, process.env.REACT_APP_TIME_ZONE)
            out = <>
                {out} -<DateTime datetime={dateTime} format={formatDate} />

            </>
            break;
        case "COMMUNI":
            out = <>{out} - {subcode}</>
            break;
    }

    return out
}

const getPdfEvent = props => {
    const row = props.cell.row.original
    let out
    let sw = Array.isArray(row?.eventUnit?.schedule?.start)

    switch (getLevelRSCPdf(row.pdfCode, row.pdfType, row.pdfSubcode)) {
        case "UNIT":
            out = <>
                <div>{row?.eventUnit?.longDescription}</div>
                {sw && <div className={'score-competitor-container  d-flex flex-row justify-content-start'}>
                    <div className='score-noc'>
                        <Noc className='me-1' {...row?.eventUnit?.schedule?.start[0]?.organisation} />
                    </div>
                    <div className='score-name'><Competitor  {...row?.eventUnit?.schedule?.start[0]?.participant} hideNoc={true} hidePicture={true} noLink={true} /> </div>
                </div>
                }
                {sw && <div className={'score-competitor-container  d-flex flex-row justify-content-start'}>
                    <div className='score-noc'>
                        <Noc className='me-1' {...row?.eventUnit?.schedule?.start[1]?.organisation} />
                    </div>
                    <div className='score-name'><Competitor  {...row?.eventUnit?.schedule?.start[1]?.participant} hideNoc={true} hidePicture={true} noLink={true} /> </div>
                </div>
                }                        </>
            break;
        case "PHASE":
            out = <div>{row?.eventUnit?.longDescription}</div>
            break;
        case "EVENT":
            let subcode
            if (row?.pdfSubcode) {
                subcode =
                    <div className={'score-competitor-container  d-flex flex-row justify-content-start'}>
                        <div className='score-noc'>
                            <Noc className='me-1' {...row?.pdfTeam?.organisation} />
                        </div>
                        <div className='score-name'> {row?.pdfTeam?.shortName}</div>
                    </div>
            }
            out = <>
                <div>{row?.eventUnit?.longDescription}</div>
                {subcode}
            </>
            break;
        case "DISCIPLINE":
        case "DATE":
        case "COMMUNI":
        case "SEX":
            out = <div>{row?.eventUnit?.longDescription}</div>
            break;
        default:
            out = "Other"
            break;
    }
    return out
}